import { ApiEpSocialAccount, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.social_account.connect.youtube.channel.set";

type Response = Await<
  ReturnType<typeof ApiEpSocialAccount.Connect.Youtube.list>
>;

type ResponseSelect = Response[string];

export const useQuerySocialAccountYoutubeChannelSet = (
  options?: Omit<
    UseQueryOptions<Response, FailureApi, ResponseSelect>,
    "queryKey" | "queryFn" | "select"
  >,
) =>
  useQuery<Response, FailureApi, ResponseSelect>(
    [KEY],
    ApiEpSocialAccount.Connect.Youtube.list,
    {
      ...options,
      select: (data) =>
        data &&
        Object.values(data).flatMap((record) =>
          Object.values(record).flatMap((page) => page),
        ),
    },
  );

useQuerySocialAccountYoutubeChannelSet.KEY = KEY;
